import { Button, Icon, Text } from "@amzn/meridian";
import React, {
  ChangeEvent,
  DragEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import folderTokens from "@amzn/meridian-tokens/base/icon/folder";

import uploadSmallTokens from "@amzn/meridian-tokens/base/icon/upload-small";
import { COLORS } from "src/constants/colors";
type ImageUploaderProps = {
  handleImageUpload: (image: File) => void;
  draggable: boolean;
};
const ImageUploader = ({
  handleImageUpload,
  draggable,
}: ImageUploaderProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFiles = useCallback((files: FileList | null) => {
    const file = files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      alert("Please upload an image file (png, jpg,etc.");
      return;
    }
    handleImageUpload(file);
  }, []);
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files);
  };
  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };
  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    // handleFiles(e.dataTransfer.files);
  };
  const handleClickUpload = () => {
    fileInputRef.current?.click();
  };
  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);
  return draggable ? (
    <>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          border: `2px dashed ${
            isDragging
              ? COLORS.IMAGE_UPLOADER_BORDER_IS_DRAGGING
              : COLORS.IMAGE_UPLOADER_BORDER
          }`,
          borderRadius: "8px",
          padding: "20px",
          textAlign: "center",
          transition: "border-color 0.2s, backgraound-color 0.2s",
          backgroundColor: isDragging
            ? COLORS.IMAGE_UPLOADER_BG_IS_DRAGGING
            : COLORS.IMAGE_UPLOADER_BG,
        }}
      >
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleInputChange}
        />

        <Button onClick={handleClickUpload}>
          <Icon tokens={uploadSmallTokens} />
          Upload file
        </Button>
        <Text>or drag file here</Text>
      </div>
    </>
  ) : (
    <>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleInputChange}
      />
      <Button type="secondary" onClick={handleClickUpload}>
        <Icon tokens={folderTokens} />
        Upload
      </Button>
    </>
  );
};

export default ImageUploader;
